export default "__VITE_ASSET__63c268ad__"